/* ============================================================
   QualitySelector — pick quality preset (draft/standard/high)
   ============================================================ */

import { QUALITY_PRESETS, type QualityPreset } from '../types';

interface QualitySelectorProps {
  selected: string;
  onSelect: (preset: QualityPreset) => void;
}

export function QualitySelector({ selected, onSelect }: QualitySelectorProps) {
  return (
    <div>
      <p style={{ fontSize: 'var(--fs-overline)', color: 'var(--color-text-secondary)', marginBottom: 'var(--space-sm)' }}>
        КАЧЕСТВО ПЕЧАТИ
      </p>
      <div style={{ display: 'flex', gap: 'var(--space-sm)' }}>
        {QUALITY_PRESETS.map((preset) => {
          const isSelected = selected === preset.key;
          return (
            <button
              key={preset.key}
              onClick={() => onSelect(preset)}
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '4px',
                padding: '14px 16px',
                borderRadius: 'var(--radius-md)',
                border: '1.5px solid',
                borderColor: isSelected ? 'var(--color-primary)' : 'var(--color-separator)',
                background: isSelected ? 'rgba(255, 149, 0, 0.06)' : 'var(--color-surface)',
                transition: 'all var(--transition-fast)',
                textAlign: 'left',
              }}
            >
              <span
                style={{
                  fontSize: 'var(--fs-body)',
                  fontWeight: isSelected ? 'var(--fw-semibold)' : 'var(--fw-medium)',
                  color: 'var(--color-text-primary)',
                }}
              >
                {preset.label}
              </span>
              <span
                style={{
                  fontSize: 'var(--fs-caption)',
                  color: 'var(--color-text-secondary)',
                  lineHeight: 1.4,
                }}
              >
                {preset.description}
              </span>
              <span
                style={{
                  fontSize: 'var(--fs-overline)',
                  color: 'var(--color-text-tertiary)',
                  marginTop: '2px',
                }}
              >
                {preset.layerHeightMm}mm · {preset.infillPercent}% infill
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
